import type { GambleStep } from "@slot/game-shell";

export const step03Lose: GambleStep = {
  outcome: "lose",
  serverChosenValue: "red",
  terminatesFlow: true,
  // base post-bet balance 100000 + newWin 0 (stake lost)
  balanceAmountMinor: "100000",
};
